import { booleanField, stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  abbreviation: stringField({ required: true }),
  department: stringField(),
  is_officer: booleanField()
};
